import { useEffect, useState } from "react";
import { reminderAPI } from "services";
import { formatMoney } from "utils";
import dayjs from "dayjs";
import { numSort, stringSort } from "utils";
import { api } from "services";
const Collection = () => {
    const [overdueAccounts, setOverdueAccounts] = useState([]);

    useEffect(() => {
        fetchOverdueAccounts();
    }, []);

    const fetchOverdueAccounts = async () => {
        const response = await reminderAPI.getOverdueAccounts();
        setOverdueAccounts(response);
    }

    const downloadPdfReport = async () => {
        //console.log("downloadReport");
        const result = await api.downloadCollectionReport();

    }

    const downloadExcelReport = () => {
        console.log("downloadReport");
    }

    const filterOverdueAccounts = () => {
        console.log("filterOverdueAccounts");
    }

    const getOverdueDays = (date) => {
        const today = new Date();
        const overdueDate = new Date(date);
        const diffTime = Math.abs(today - overdueDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays;
    }

    // const sortColumn = (column) => {
    //     console.log("sortColumn", column);
    //     console.log("overdueAccounts", overdueAccounts);
    //     let sortedAccounts = overdueAccounts.get("accountId");
    //     console.log("sortedAccounts", sortedAccounts);
    //     let sortedAccountArray = [...sortedAccounts];
    //     if (column === "balance") {
    //         sortedAccounts = numSort(sortedAccountArray, "balance");

    //     } else {
    //         sortedAccounts = stringSort(sortedAccountArray, "accountId.name");
    //     }
    //     setOverdueAccounts(sortedAccounts);
    // }

    return (
        <div className="row">
            <div className="col-md-12 col-12 ms-3">
                <div className="row pt-3">
                    <div className="col-md-9">
                        <h2>Collection Report</h2>
                    </div>
                    <div className="col-md-3" align="right">
                        <button className="btn btn-lg btn-outline-app me-2" disabled onClick={filterOverdueAccounts}><i className="bi bi-filter"></i></button>
                        <button className="btn btn-lg btn-outline-app me-2" disabled onClick={downloadExcelReport}><i className="bi bi-file-earmark-excel-fill"></i></button>
                        <button className="btn btn-lg btn-outline-app" onClick={downloadPdfReport}><i className="bi bi-file-earmark-pdf-fill"></i></button>
                    </div>
                </div>
                <hr />
                <div className="table table-striped table-hover table-responsive mt-3">
                    <thead className="text-light bg-app">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Overdue Amount</th>
                            <th scope="col">#Days</th>
                            <th scope="col">Account Type</th>
                            <th scope="col">Address</th>

                        </tr>
                    </thead>
                    <tbody className="table-group-divider">
                        {overdueAccounts.map((overdueAccount, index) => (
                            <tr key={overdueAccount.id}>
                                <th scope="row">{index + 1}</th>
                                <td>{overdueAccount.get("accountId").get("name")}</td>
                                <td>{overdueAccount.get("accountId").get("phone")}</td>
                                <td className="fw-bold" align="right">{formatMoney(overdueAccount.get("accountId").get("balance"))}</td>
                                <td align="right">{getOverdueDays(overdueAccount.get("date"))}</td>
                                <td>{overdueAccount.get("accountId").get("tag")}</td>
                                <td className="text-wrap"><small>{overdueAccount.get("accountId").get("address")}</small></td>
                            </tr>
                        ))}
                    </tbody>
                </div>
            </div>
        </div>
    )
}
export default Collection;